module.exports = __webpack_public_path__ + "static/media/VectorOptions.8e9ce2b3.svg";